import { Component, OnInit, signal, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ShopService } from '@shared/services/shop.service';
import { ShopOffersInventory } from '@shared/models/inventory.model';
import { UserService } from '@shared/services/user.service';
import { User } from '@shared/models/user.model';
import { takeUntil } from 'rxjs/operators';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';
import { Modal, ModalType, NonPersistedModalName } from '@shared/models/modal.model';
import { EventManager } from '@shared/utils/event-manager';
import { LoggerService } from '@shared/services/logger.service';
import { Observable } from 'rxjs';
import { WalletComponent } from '@app/shared/components/wallet/wallet.component';
import { AnchorTabDisplayComponent } from '@shared/components/anchor-tab-display/anchor-tab-display.component';
import { GoldenBombComponent } from '@app/shared/components/golden-bomb/golden-bomb.component';
import { ShopOfferComponent } from '@shared/components/shop-offer/shop-offer.component';
import { SharedModule } from '@shared/shared.module';
import { RichclubIconComponent } from '@app/shared/components/icon/rich-club-icon/rich-club-icon.component';
import { AnalyticsService } from '@app/shared/services/analytics.service';
import { ShopRatesRepository } from '@app/shared/state/shop-rates/shop-rates.repository';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-shop-modal',
  templateUrl: './shop-modal.component.html',
  styleUrls: ['./shop-modal.component.scss'],
  standalone: true,
  imports: [
    WalletComponent,
    AnchorTabDisplayComponent,
    GoldenBombComponent,
    ShopOfferComponent,
    AnchorTabDisplayComponent,
    GoldenBombComponent,
    SharedModule,
    RichclubIconComponent,
  ],
})
export class ShopModalComponent implements OnInit {
  inventory: ShopOffersInventory;
  loading = signal(true);
  loadingError = signal(false);
  sectionToGo = signal<string>('');
  disableBackButton = true;
  user: User;

  componentDestroy: () => Observable<unknown>;

  private readonly shopService = inject(ShopService);
  private readonly userService = inject(UserService);
  private readonly eventManager = inject(EventManager);
  public readonly logger = inject(LoggerService);
  private readonly analyticsService = inject(AnalyticsService);
  private readonly shopRatesRepo = inject(ShopRatesRepository);

  readonly shopModalData = inject<Modal>(MAT_DIALOG_DATA);

  ngOnInit() {
    if (this.shopModalData) {
      this.sectionToGo.set(this.shopModalData.data.tab);
    }

    this.analyticsService.logEvent('custom_store_impression', this.sectionToGo() === 'left' ? 'coins' : 'gems');
    this.userService.currentUser$.pipe(takeUntil(this.componentDestroy())).subscribe({
      next: (user: User) => {
        this.user = user;
        this.shopService
          .getShopWithPrices()
          .pipe(takeUntil(this.componentDestroy()))
          .subscribe({
            next: (inventory: ShopOffersInventory) => {
              if (!inventory) {
                this.loadingError.set(true);
                this.loading.set(false);
              }

              this.inventory = inventory;
              this.shopRatesRepo.setShopRates(inventory);

              this.loading.set(false);
            },
            error: (err) => {
              this.logger.error(err);

              switch (err.status) {
                case 422:
                  this.logger.log('(SLOTCOM) - 422 - Shop Inventory param error.');
                  break;
                case 423:
                  this.logger.log('(SLOTCOM) - 423 - Shop Blocked by Flag.');
                  break;
                case 500:
                  this.logger.log('(SLOTCOM) - 500 - Shop Inventory server error.');
                  break;
                default:
                  break;
              }

              this.loadingError.set(true);
              this.loading.set(false);
            },
          });
      },
      error: (error) => this.logger.error(error),
    });

    setTimeout(() => {
      this.disableBackButton = false;
    }, 1500);
  }

  public closeModal() {
    this.eventManager.closeModal(
      new Modal(NonPersistedModalName.ShopModalComponent, ModalType.View, this.shopModalData)
    );
  }
}
